// FETCH TIPS
export const FETCH_MEDIA_COMMENTS_REQUEST = 'media-comments/FETCH_MEDIA_COMMENTS_REQUEST';
export const FETCH_MEDIA_COMMENTS_COMPLETED = 'media-comments/FETCH_MEDIA_COMMENTS_COMPLETED';
export const FETCH_MEDIA_COMMENTS_FAILED = 'media-comments/FETCH_MEDIA_COMMENTS_FAILED';

export const FETCH_COMMENTS_BY_FILTER_REQUEST = 'media-comments/FETCH_COMMENTS_BY_FILTER_REQUEST';
export const FETCH_COMMENTS_BY_FILTER_COMPLETED = 'media-comments/FETCH_COMMENTS_BY_FILTER_COMPLETED';
export const FETCH_COMMENTS_BY_FILTER_FAILED = 'media-comments/FETCH_COMMENTS_BY_FILTER_FAILED';

export const FETCH_NEW_COMMENTS_REQUEST = 'media-comments/FETCH_NEW_COMMENTS_REQUEST';
export const FETCH_NEW_COMMENTS_COMPLETED = 'media-comments/FETCH_NEW_COMMENTS_COMPLETED';
export const FETCH_NEW_COMMENTS_FAILED = 'media-comments/FETCH_NEW_COMMENTS_FAILED';

export const COMMENT_LIKE_REQUEST = 'media-comments/COMMENT_LIKE_REQUEST';
export const COMMENT_LIKE_COMPLETED = 'media-comments/COMMENT_LIKE_COMPLETED';
export const COMMENT_LIKE_FAILED = 'media-comments/COMMENT_LIKE_FAILED';

export const COMMENT_DELETE_REQUEST = 'media-comments/COMMENT_DELETE_REQUEST';
export const COMMENT_DELETE_COMPLETED = 'media-comments/COMMENT_DELETE_COMPLETED';
export const COMMENT_DELETE_FAILED = 'media-comments/COMMENT_DELETE_FAILED';

export const SEND_COMMENT_REQUEST = 'media-comments/SEND_COMMENT_REQUEST';
export const SEND_COMMENT_COMPLETED = 'media-comments/SEND_COMMENT_COMPLETED';
export const SEND_COMMENT_FAILED = 'media-comments/SEND_COMMENT_FAILED';

export const COMMENT_UPDATE_COMPLETED = 'media-comments/COMMENT_UPDATE_COMPLETED';
